import React from "react";
import { createUseStyles } from "react-jss";
import TariffOrderBlockContainer from "../Containers/TariffOrderBlockContainer";

const useStyles = createUseStyles((theme) => ({
	wrapper: {
		position: "relative",
		backgroundColor: theme.palette.colors.white,
		borderRadius: "20px",
		margin: "30px 0 0",
	},
	root: {
		margin: "0 auto",
	},
	close: {
		position: "absolute",
		top: "-20px",
		right: "10%",
		cursor: "pointer",
		backgroundColor: theme.palette.colors.white,
		border: "1px solid " + theme.palette.colors.cloudyBlue,
		borderRadius: "100%",
		padding: "15px 17px",
		boxShadow: "0px 4px 4px 0px #00000040",
		"& span": {
			color: theme.palette.colors.disabled,
			fontSize: "16px",
		},
	},
}));

const TariffOrderBlock = (props) => {
	const { wrapper, root, close } = useStyles();

	return (
		<div className={wrapper}>
			<div className={root}>
				<TariffOrderBlockContainer {...props} />
			</div>
			<div className={close} onClick={props.closeModal}>
				<span className="icon24 icon-close" />
			</div>
		</div>
	);
};
export default TariffOrderBlock;
